import { getSettings } from '@app/src/configuration/config.service';
import { hydrateUser } from './hydrators';
import { HttpStatus } from '@app/src/utils/validations/constants';
import axios from 'axios';

export const serviceLoginMfa = {
  async loginVerificateOtp(values, url) {
    try {

      const whitelist = Object.values(getSettings()).filter(value => value.startsWith('https://') || value.startsWith('http://'));
      const accessToken = sessionStorage.getItem('mfaAccessToken');
      if(whitelist.includes(url)){
        var data = await axios.post(url, {otp: values.otp}, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });

        if (data.data.code === HttpStatus.LOGIN_SESSIONTOKEN_ERROR) {
          return data.data;
        }
        if (data.data.code === HttpStatus.LOGIN_OTP_ERROR) {
          return data.data;
        }
        if (data.data.code === HttpStatus.LOGIN_EXCEEDED_OTP_ATTEMPTS_ERROR) {
          return data.data;
        }

        const refreshtoken = data.headers.authorization;
        localStorage.setItem('refreshtoken', refreshtoken);
        return hydrateUser(data.data);
      }else{
        return null;
      }

    } catch (e) {
      throw e.response.data;
    }
  },

  async resendOtp(url) {
    try {
      const accessToken = sessionStorage.getItem('mfaAccessToken');
      const whitelist = Object.values(getSettings()).filter(value => value.startsWith('https://') || value.startsWith('http://'));
      if(whitelist.includes(url)){
        var response = await axios.post(url, {}, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        return response.data
      }else{
        return null; 
      }
    } catch (e) {
      throw e.response.data;
    }
  }
}
